import Vue from 'vue'
import App from './App.vue'
// import '../../config/rem'
import api from '../../fetch/api'
Vue.prototype.$api = api
Vue.config.productionTip = (process.env.NODE_ENV !== 'production')
// Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
